// Figma: "Alert" component (node 18050:8, e.g. instance at 18050:300 in the
// login-account-not-found screen) — persistent inline banner shown above the form for
// errors the user should keep seeing while they retry (e.g. "no account found").
import React from 'react';
import PropTypes from 'prop-types';
import {Box, Stack, Typography} from '@mui/material';
import circleAlertIcon from '../../../assets/auth/circle-alert-icon.svg';

const AlertBanner = ({title, description}) => (
    <Box
        sx={{
            width: '100%',
            display: 'flex',
            gap: '10px',
            p: 2,
            borderRadius: '8px',
            backgroundColor: 'rgba(251,44,54,0.1)',
            border: '1px solid rgba(251,44,54,0.25)'
        }}
    >
        <Box component="img" src={circleAlertIcon} alt="" sx={{width: 20, height: 20, flexShrink: 0}} />
        <Stack spacing={0.5}>
            <Typography variant="body2" fontWeight={500} color="error.main">
                {title}
            </Typography>
            <Typography variant="body2" sx={{color: 'rgba(251,44,54,0.9)'}}>
                {description}
            </Typography>
        </Stack>
    </Box>
);

AlertBanner.propTypes = {
    title: PropTypes.string.isRequired,
    description: PropTypes.node.isRequired
};

export default AlertBanner;
